<template>
  <div class="captcha-container">
    <el-input 
      type="text" 
      v-model="userInput" 
      :placeholder="$t('ContactPage.message.captcha')"
      class="captcha-input"
      @input="$emit('input')"
    ></el-input>
    <canvas 
      ref="captchaCanvas" 
      :width="width" 
      :height="height"
      @click="refreshCaptcha"
      class="captcha-canvas"
      title="点击刷新"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: 'captchaView',
  props: {
    width: {
      type: Number,
      default: 120
    },
    height: {
      type: Number,
      default: 38
    },
    length: {
      type: Number,
      default: 4
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('ContactPage.message.captcha')
      }
    }
  },
  data() {
    return {
      userInput: '',
      code: '' // 生成的验证码
    }
  },
  mounted() {
    this.generateCaptcha();
  },
  methods: {
    // 生成验证码
    generateCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext('2d');
      
      // 清空画布
      ctx.clearRect(0, 0, this.width, this.height);
      
      // 绘制背景
      ctx.fillStyle = '#f3f3f3';
      ctx.fillRect(0, 0, this.width, this.height);
      
      // 生成随机验证码
      const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      this.code = '';
      for (let i = 0; i < this.length; i++) {
        this.code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      
      // 绘制验证码
      ctx.font = 'bold ' + (this.height * 0.7) + 'px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // 每个字符随机颜色和位置
      for (let i = 0; i < this.code.length; i++) {
        // 随机颜色
        const color = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
        ctx.fillStyle = color;
        
        // 随机旋转角度
        const angle = (Math.random() - 0.5) * 0.5;
        
        // 绘制字符
        ctx.save();
        ctx.translate(this.width / (this.length + 1) * (i + 1), this.height / 2);
        ctx.rotate(angle);
        ctx.fillText(this.code.charAt(i), 0, 0);
        ctx.restore();
      }
      
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = `rgb(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200})`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * this.width, Math.random() * this.height);
        ctx.lineTo(Math.random() * this.width, Math.random() * this.height);
        ctx.stroke();
      }
      
      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200})`;
        ctx.beginPath();
        ctx.arc(Math.random() * this.width, Math.random() * this.height, 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    },
    
    // 刷新验证码
    refreshCaptcha() {
      this.generateCaptcha();
      this.userInput = '';
      this.$emit('input'); // 刷新时也触发input事件
    },
    
    // 验证输入是否正确
    validate() {
      return this.userInput.toUpperCase() === this.code;
    },
    
    // 清空输入
    clear() {
      this.userInput = '';
    }
  }
}
</script>

<style scoped>
.captcha-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-canvas {
  cursor: pointer;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin-right: 15px;
}

.captcha-input {
  /* padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px; */
  width: 120px;
}
</style>
